/**
 * Button to start initial tour phase 1
 * @author Matt Haynes
 * @package Dunfermline
 */

export default class StartTour {
    constructor(elem) {
        if (!elem) {
            return;
        }
        this.elem = elem;
        this.map = document.getElementById('map');
        this.tourContainer = document.getElementById('tour_container');
        this.contentSection = document.querySelector('.content-section');
        this.landingBody = document.getElementById('landing_content');
        this.tourBody = document.getElementById('tour_content');
        this.initialInfo = document.querySelector('.initial-information');
        this.continueToTour = document.querySelector('.continue-tour');
        this.toggleContent = document.getElementById('toggle_content');
        // eslint-disable-next-line
        this.controlButtons = Array.from(
            document.querySelectorAll('.tour_content__contentButton'),
        );
        this.markVisited = document.getElementById('visited');
        this.spotifyPlayer = document.getElementById('spotify-player');
        this.burgerMenu = document.querySelector('.hamburger');
        this.homeMenu = document.querySelector('.home-link');
        this.audioContainer = document.getElementById('audio-container');
        this.audioPlayer = document.getElementById('audio-player');
        this.locationContinueButton = document.getElementById(
            'location-continue',
        );
        this.locationContinueContainer = document.getElementById('location');

        this.elem.addEventListener('click', () => {
            this.startTour();
        });

        this.continueToTour.addEventListener('click', () => {
            this.continueTour();
        });

        this.locationContinueButton.addEventListener('click', () => {
            this.locationContinue();
        });
    }

    startTour() {
        this.map.classList.remove('init');
        this.tourContainer.classList.add('toggled');
        this.contentSection.classList.add('toggled');
        this.landingBody.classList.add('hide');
        this.initialInfo.classList.remove('hide');
        this.continueToTour.classList.remove('hide');
        this.locationContinueContainer.style.display = 'flex';
        // if (this.burgerMenu) this.burgerMenu.style.display = 'none';
        // if (this.homeMenu) this.homeMenu.style.display = 'none';

        setTimeout(() => {
            this.landingBody.style.display = 'none';
        }, 500);
    }

    locationContinue() {
        this.locationContinueContainer.style.display = 'none';
    }

    continueTour() {
        this.tourContainer.classList.remove('toggled');
        this.contentSection.classList.remove('toggled');
        this.contentSection.classList.add('tour-started');
        this.initialInfo.classList.add('hide');
        this.continueToTour.classList.add('hide');
        this.tourBody.querySelector('.tour-content').classList.remove('hide');
        this.toggleContent.classList.remove('hide');
        this.controlButtons.forEach(button => button.classList.remove('hide'));
        this.markVisited.classList.remove('hide');
        this.controlButtons.forEach(button => button.classList.remove('hide'));
        this.markVisited.classList.remove('hide');
        if (this.spotifyPlayer && this.spotifyPlayer.getAttribute('data-src').length > 0) {
            this.spotifyPlayer.classList.remove('hide');
            this.spotifyPlayer.classList.remove('init-hide');
        }
        if (this.audioContainer && this.audioPlayer.src.length > 0) {
            this.audioContainer.classList.remove('hide');
            this.audioContainer.classList.remove('init-hide');
        }
    }
}
